import { render, staticRenderFns } from "./IcoDocsPendingOther.vue?vue&type=template&id=0707162c"
import script from "./IcoDocsPendingOther.vue?vue&type=script&lang=js"
export * from "./IcoDocsPendingOther.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports